"use client";

import { useEffect, useState } from "react";
import { useMediaMatches } from "@/hooks/use-mobile";

export function useDemoLoop(count: number, intervalMs: number) {
  const prefersReducedMotion = useMediaMatches("(prefers-reduced-motion: reduce)");
  const [chosenPlaying, setChosenPlaying] = useState<boolean | null>(null);
  const [active, setActive] = useState(0);
  const isPlaying = chosenPlaying ?? !prefersReducedMotion;
  useEffect(() => {
    if (!isPlaying) return;
    const timer = window.setInterval(() => setActive((current) => (current + 1) % count), intervalMs);
    return () => window.clearInterval(timer);
  }, [isPlaying, count, intervalMs]);
  return {
    active,
    isPlaying,
    pick: (index: number) => {
      setChosenPlaying(false);
      setActive(index);
    },
    toggle: () => setChosenPlaying(!isPlaying),
  };
}
